import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { useFormInput } from "@/utils";
import { Confirm, Toast } from "@/components";
import SearchAddress from "@/components/Modal/Common/SearchAddress";
import { useGetChargeDetailQuery } from "../../redux/chargeApi";
import { comma, dateFormatDateTime, formatPhoneNumber } from "../../utils";
import { chargeStatusOptions, contractStatusOptions } from "../../constants/selectOptions";

export const BillingDetail = () => {
    const { chargeId } = useParams();
    const navigate = useNavigate();
    const [resetPasswordPopupVisible, setResetPasswordPopupVisible] = useState(false);
    const [isDetailLoading, setIsDetailLoading] = useState(false);

    const { formData, handleChange, setFormData } = useFormInput({
        mode: "CREATE", // "CREATE" / "READ" / "UPDATE"
        isLoading: false,
        toastMsg: "",
        confirmStatus: {
            confirmPopupStatus: false,
            confirmTitle: "",
            confirmDescription: "",
            confirmButtons: [],
        },
        addressPopupStatus: false,
        id: null,
        member: {},
        rentCorps: [],
        selectedRentCorp: {},
    });
    const { mode, isLoading, toastMsg, confirmStatus, addressPopupStatus, id } = formData;

    const { data: chargeDetailData, refetch: refetchChargeDetail } = useGetChargeDetailQuery(chargeId, {
        skip: !chargeId,
    });

    useEffect(() => {
        console.log(formData);
    }, [formData]);

    useEffect(() => {
        // CREATE 모드일 때 early return
        if (!chargeId) return;

        if (chargeDetailData && chargeDetailData.data) {
            const response = chargeDetailData.data;
            setFormData((prev) => ({
                ...prev,
                isLoading: false,
                ...response,
                // 필요시 contractCar 등 다른 필드도 추가 매핑
            }));
        }
    }, [chargeId, chargeDetailData, setFormData]);

    // 모드 설정: memberId 있으면 "UPDATE"
    useEffect(() => {
        if (chargeId) {
            refetchChargeDetail(chargeId);
            setFormData((prev) => ({
                ...prev,
                mode: "UPDATE",
                id: chargeId,
            }));
        }
    }, [chargeId, setFormData]);

    const showFaxFile = () => {
        if (!formData.faxFileUrl) {
            setFormData((prev) => ({
                ...prev,
                toastMsg: "팩스파일이 생성되지 않은 상태 입니다.",
            }));
            return;
        }
        window.open(formData.faxFileUrl, "_blank");
    };

    return (
        <>
            {toastMsg && <Toast visible={true} msg={toastMsg} setFormData={setFormData} />}

            <div className="management-form container">
                <div className="form-container">
                    <div className="form-head">
                        <div className="head-tit">
                            <span className="form_name">청구 상세</span>
                            <span className="form_desc"></span>
                        </div>
                        <div className="head-options">
                            <button type="button" className="btn btn-outline" onClick={() => navigate(-1)}>
                                이전으로
                            </button>
                            <button type="button" className="btn btn-save" onClick={showFaxFile}>
                                팩스파일보기
                            </button>
                            <button
                                type="button"
                                className="btn btn-outline"
                                onClick={() => navigate(`/contract/detail/${formData.contractGroup?.id}`)}
                            >
                                계약상세
                            </button>
                        </div>
                    </div>

                    <div className="form-content">
                        <div className="form-wrapper">
                            <div className="form-item">
                                <div className="item-head">
                                    <span className="form-item_tit">기본 정보</span>
                                    <div className="form-item_etc"></div>
                                </div>
                                <div className="item-body">
                                    <div className="item-list">
                                        <ChargeInfo formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                    </div>
                                </div>
                            </div>

                            <div className="form-item">
                                <div className="item-head">
                                    <span className="form-item_tit">보험사 정보</span>
                                    <div className="form-item_etc"></div>
                                </div>
                                <div className="item-body">
                                    <div className="item-list">
                                        <InsuranceCorpInfo formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                    </div>
                                </div>
                            </div>

                            <div className="form-item">
                                <div className="item-head">
                                    <span className="form-item_tit">계약 정보</span>
                                    <div className="form-item_etc"></div>
                                </div>
                                <div className="item-body">
                                    <div className="item-list">
                                        <ContractInfo formData={formData} handleChange={handleChange} setFormData={setFormData} />
                                    </div>
                                </div>
                            </div>

                            <div className="form-item">
                                <div className="item-head">
                                    <span className="form-item_tit">대여 정보</span>
                                    <div className="form-item_etc"></div>
                                </div>
                                <div className="item-body">
                                    {formData.chargeItems &&
                                        formData.chargeItems.length > 0 &&
                                        formData.chargeItems.map((item, index) => (
                                            <div className="item-list" key={item.id}>
                                                <RentInfo
                                                    formData={formData}
                                                    handleChange={handleChange}
                                                    setFormData={setFormData}
                                                    chargeItem={item}
                                                />
                                            </div>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Confirm 팝업 */}
            {confirmStatus.confirmPopupStatus && (
                <Confirm
                    layer={true}
                    onClose={() =>
                        setFormData((prev) => ({
                            ...prev,
                            confirmStatus: { confirmPopupStatus: false },
                        }))
                    }
                    title={confirmStatus.confirmTitle}
                    description={confirmStatus.confirmDescription}
                    buttons={confirmStatus.confirmButtons}
                />
            )}

            {/* 주소 검색 팝업 */}
            {addressPopupStatus && (
                <SearchAddress
                    modalStatus={addressPopupStatus}
                    setModalStatus={() =>
                        setFormData((prev) => ({
                            ...prev,
                            addressPopupStatus: false,
                        }))
                    }
                    setAddress={(data) =>
                        setFormData((prev) => ({
                            ...prev,
                            parkingLotAddress: data.address,
                            parkingLotBCode: data.bcode,
                        }))
                    }
                />
            )}
        </>
    );
};

/* 기본 정보 */
const ChargeInfo = ({ formData, handleChange, setFormData }) => {
    return (
        <>
            {/* 로그인 ID */}
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>업체명</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="rentCorp.corpName"
                            placeholder=""
                            value={formData.rentCorp?.corpName || ""}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>사고차량번호</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="contractGroup.accidentCar.carNumber"
                            placeholder=""
                            value={formData.contractGroup?.accidentCar?.carNumber || ""}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>청구시도횟수</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="chargeCount"
                            placeholder=""
                            value={formData.chargeCount || "0"}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>팩스전송여부</span>
                </div>
                <div className="row-content">
                    <span className="item-desc">
                        <span
                            className="cell-dag tag-box"
                            style={{
                                backgroundColor: !formData.faxStatus
                                    ? "#ffebee"
                                    : formData.faxStatus === "PENDING"
                                    ? "#e8f5e9"
                                    : formData.faxStatus === "FAIL"
                                    ? "#ffebee"
                                    : formData.faxStatus === "FINISH"
                                    ? "#e8f5e9"
                                    : "#e8f5e9",
                            }}
                        >
                            {!formData.faxSentAt
                                ? "미전송"
                                : formData.faxStatus === "PENDING"
                                ? "전송중"
                                : formData.faxStatus === "FAIL"
                                ? "전송실패"
                                : formData.faxStatus === "FINISH"
                                ? "전송완료"
                                : ""}
                        </span>
                    </span>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>팩스전송시각</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="contractCar"
                            placeholder=""
                            value={dateFormatDateTime(formData.faxSentAt || "")}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>청구상태</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="contractCar"
                            placeholder=""
                            value={chargeStatusOptions.find((item) => item.value === formData.chargeStatus)?.label || ""}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

/* 기본 정보 */
const RentInfo = ({ formData, handleChange, setFormData, chargeItem }) => {
    return (
        <>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>대여차량</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="contractCar"
                            placeholder=""
                            value={chargeItem.contract?.contractCar?.carNumber || ""}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>대여일수</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="contractCar"
                            placeholder=""
                            value={(chargeItem.rentDays || "0") + "일" + (chargeItem.rentHours || "0") + "시간"}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>총대여료</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="contractCar"
                            placeholder=""
                            value={comma(chargeItem.rentFee) + "원"}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>보험사청구금</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="contractCar"
                            placeholder=""
                            value={comma(chargeItem.insuranceChargeFee) + "원"}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>청구율</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="contractCar"
                            placeholder=""
                            value={chargeItem.chargeRate + "%"}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>입금 금액</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="contractCar"
                            placeholder=""
                            value={chargeItem.totalDepositPrice || "0" + "원"}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

const ContractInfo = ({ formData, handleChange, setFormData }) => {
    return (
        <>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>계약번호</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="contractCar"
                            placeholder=""
                            value={formData.contractGroup?.serialNumber || ""}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>계약상태</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="contractCar"
                            placeholder=""
                            value={contractStatusOptions.find((item) => item.value === formData.contractGroup?.contractStatus)?.label || ""}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>고객명</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="contractCar"
                            placeholder=""
                            value={formData.contractGroup?.customerName || ""}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>고객연락처</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="contractCar"
                            placeholder=""
                            value={formatPhoneNumber(formData.contractGroup?.customerPhone || "")}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

const InsuranceCorpInfo = ({ formData, handleChange, setFormData }) => {
    return (
        <>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>보험사</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="order.orderInsurance.insuranceCorpName"
                            placeholder=""
                            value={formData.order?.orderInsurance?.insuranceCorpName || ""}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>보험접수번호</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="contractGroup.contractInsurance.receiptNumber"
                            placeholder=""
                            value={formData.contractGroup?.contractInsurance?.receiptNumber || ""}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </div>
                </div>
            </div>

            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>보험사 팩스번호</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="chargeCount"
                            placeholder=""
                            value={formData.faxNumber || ""}
                            onChange={handleChange}
                            disabled={true}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
